module.exports = __webpack_public_path__ + "img/life-icon-green.52121a55.png";